module.exports = __webpack_public_path__ + "0022d5a7ac9e5944dd65e6bb0af9492e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/user.png
// module id = 219
// module chunks = 0